import {Card, Col, Row} from "react-bootstrap";
import CardMenu from "../../components/card-menu";

import {useEnterprise} from "./EnterpriseProvider";
import Menu from "./Menu";
import {SendersForm} from "./SendersForm";
import {useEffect, useState} from "react";
import {SendersList} from "./SendersList";
import Loading from "../generic/Loading";
import {fetchSenders} from "./api";


export const Senders = () => {

    const {enterprise, domain, loading} = useEnterprise();
    const idEnterprise = enterprise?._id?.$oid;
    const EnterpriseMenu = Menu({id: idEnterprise, domain})
    const [sender, setSender] = useState()
    const [senders, setSenders] = useState([])
    const [isLoading, setIsLoading] = useState(false)



    const handleUpsert = (sender) => {
        setSenders(prevState => [...prevState, sender])
    }


    useEffect(() => {
        if(domain){
            setIsLoading(true)
            fetchSenders(domain?._id?.$oid).then(response => {
                setSenders(response)
                setIsLoading(false)
            })
        }
    }, [domain])


    return (
        <Card>
            <CardMenu {...EnterpriseMenu} />

            <div style={{position: 'relative'}}>
                {(loading || isLoading)
                    ? <Loading styles={{height: 'calc(100vh - 300px)'}}/>
                    : <Row>
                        <Col sm={4}>
                            <div className="max-width-600">
                                <SendersForm
                                    domain={domain}
                                    sender={sender}
                                    onUpsert={handleUpsert}
                                />
                            </div>
                        </Col>
                        <Col sm={8}>
                            <SendersList
                                senders={senders}
                                setSender={setSender}
                                setSenders={setSenders}
                                enterprise={enterprise}
                            />
                        </Col>
                    </Row>
                }
            </div>
        </Card>
    )
}